import { FC, useId } from "react";

export const SymbioticIcon: FC<{ className?: string }> = ({ className }) => {
  const id = useId();

  const clipPathId0 = `symbiotic-clip-path-0-${id}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <g clip-path={`url(#${clipPathId0})`}>
        <path
          d="M16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8Z"
          fill="#B6FF3E"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.36363 4.36365H11.5742V5.15817H5.17173V6.5027H11.6364V11.6364H4.42579V10.8419H10.8283V9.49732H4.36363V4.36365ZM10.8283 8.70285V7.29717H5.17173V8.70285H10.8283Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id={clipPathId0}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
